const findCommonElements = (arr1, arr2) => {
  return arr1.includes(arr2);
};

export default findCommonElements;
